export const API_URL = 'https://fasocial.azurewebsites.net/api';
export const FILE_UPLOAD_URL = 'https://fuss-media-dev.azurewebsites.net/api';
// export const API_URL = 'http://localhost:8080/api';
// export const FILE_UPLOAD_URL = 'http://localhost:8080/api';

export const FILE_DOWNLOAD_BASE_URL = 'https://safusssample.blob.core.windows.net/file-upload';
export const FILE_DOWNLOAD_KEY = 'sv=2022-11-02&ss=bf&srt=sco&sp=rwdlaciytfx&se=2024-10-26T00:29:16Z&st=2024-09-10T16:29:16Z&spr=https&sig=keSyyk6m6TWY0fNw9%2FjB8j4bn7MG5nFbTH6ELue3Pe4%3D';
